<template>
  <TheMaster
    v-if="$store.state.master.isSignin"
    title="사용자 추가"
    description="새로운 사용자를 추가합니다."
    :color="true"
  >
    <a-row :gutter="16" type="flex">
      <a-col :span="24" class="mt">
        <a-spin tip="로딩 중..." :spinning="isLoading">
          <a-card title="계정 정보">
            <a-form-item
              label="업체 이름:"
              :validate-status="details.name ? 'error' : ''"
              :help="details.name"
            >
              <a-input v-model="company.name" />
            </a-form-item>
            <a-form-item
              label="아이디:"
              :validate-status="details.identity ? 'error' : ''"
              :help="details.identity"
            >
              <a-input v-model="company.identity" />
            </a-form-item>
            <a-form-item
              label="사이트 주소:"
              :validate-status="details.hostname ? 'error' : ''"
              :help="details.hostname"
            >
              <a-input v-model="company.hostname">
                <a-select slot="addonAfter" defaultValue=".brosaib.com" v-model="tld">
                  <a-select-option value=".brosaib.com">.brosaib.com</a-select-option>
                  <a-select-option value>커스텀</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
            <a-row :gutter="16">
              <a-col :md="12" :span="24">
                <a-form-item
                  label="전화번호:"
                  :validate-status="details.phone ? 'error' : ''"
                  :help="details.phone"
                >
                  <a-input @change="getMask('phone')" v-model="company.phone" />
                </a-form-item>
              </a-col>
              <a-col :md="12" :span="24">
                <a-form-item
                  label="이메일:"
                  :validate-status="details.email ? 'error' : ''"
                  :help="details.email"
                >
                  <a-input v-model="company.email" />
                </a-form-item>
              </a-col>
              <a-col :span="24">
                <a-form-item
                  label="만료일:"
                  :validate-status="details.expiry ? 'error' : ''"
                  :help="details.expiry"
                >
                  <a-date-picker v-model="company.expiry" format="LL" :showToday="false" />
                </a-form-item>
              </a-col>
            </a-row>
            <p>비밀번호는 이메일과 전화번호로 전송됩니다.</p>
          </a-card>
        </a-spin>
      </a-col>
    </a-row>

    <a-button
      :loading="isLoading"
      @click="onApply"
      class="fl-right mt"
      type="primary"
      icon="plus"
    >추가</a-button>
  </TheMaster>
</template>
<script>
import TheMaster from "@/components/Master/TheMaster";
import config from "../../../config";
import Axios from "axios";
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import OPCODE from "../../../libs/OPCODE";
import router from "../../../router";

export default {
  name: "MasterUsers",
  components: { TheMaster },
  data() {
    return {
      tld: ".brosaib.com",
      isLoading: false,
      statusLoading: false,
      details: {},
      company: {
        name: "",
        identity: "",
        hostname: "",
        email: "",
        phone: "",
        expiry: this.$moment()
      }
    };
  },
  methods: {
    async onApply() {
      this.isLoading = true;
      this.details = { balance: {}, business: {} };
      try {
        const { data } = await Axios.post(
          `${config.hostname}/v1/master/users/`,
          {
            name: this.company.name,
            identity: this.company.identity,
            hostname: this.company.hostname + this.tld,
            email: this.company.email,
            phone: this.company.phone,
            expiry: this.company.expiry
          },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              router.push(`/master/users/${data.idx}`);
              config.alert.mixin({
                type: "success",
                title: "성공적으로 추가 되었습니다."
              });
              break;
            case OPCODE.EXISTS:
              config.alert.mixin({
                type: "warning",
                title: "해당 아이디 또는 전화번호, 이메일, 주소는 사용중입니다."
              });
              break;
            case OPCODE.INVALID:
              this.details = data.details;

              config.alert.mixin({
                type: "warning",
                title: "오류를 확인해주세요."
              });
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "알 수 없는 이유로 추가할 수 없습니다."
              });
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "추가할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
      this.isLoading = false;
    },
    getMask(type) {
      let num = this.company[type].replace(/[^0-9]/g, "");

      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      this.company[type] = res;
    }
  }
};
</script>
<style>
.mt {
  margin-top: 20px;
}
</style>